//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import GdprCookieModal from '@/modules/gdpr/components/GdprCookieModal'
import EkbModal from '@/modules/ekbModal/components/EkbModal'
import BarnaulModal from '@/modules/barnaulModal/components/BarnaulModal'
import NovosibirskModal from '@/modules/novosibirskModal/components/NovosibirskModal'
import Preloader from '@/components/common/Preloader'
import Modals from '~/components/common/section/Modals'
import CityBillet from '~/components/modals/CityBillet'

import Header from '~/components/redesign/Header'
import Footer from '~/components/redesign/Footer'

export default {
  name: 'Course',
  components: {
    EkbModal,
    Modals,
    BarnaulModal,
    NovosibirskModal,
    Header,
    Footer,
    GdprCookieModal,
    CityBillet,
    Preloader,
  },
  computed: mapGetters({
    mainSettings: 'landings/mainSettings',
    isNewDesign: 'landings/featureEnabled',
    gdprSaved: 'gdpr/gdprSaved',
  }),
}
